import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { Helmet } from 'react-helmet';
import './WelcomeScreen.css';

const WelcomeScreen = () => {
    const { user } = useAuth();
    const { companyName } = useBranding();

    return (
        <>
            <Helmet>
                <title>Bienvenido - {companyName}</title>
            </Helmet>
            <Container fluid className="welcome-screen-container">
                <Row className="justify-content-center align-items-center min-vh-100">
                    <Col lg={8} xl={6}>
                        <Card className="welcome-card">
                            <Card.Body className="text-center p-5">
                                <div className="welcome-icon mb-4">
                                    <i className="fas fa-paw fa-5x"></i>
                                </div>
                                <h1 className="welcome-title mb-3">
                                    ¡Bienvenido a {companyName}!
                                </h1>
                                <h4 className="welcome-subtitle mb-4">
                                    {user?.email}
                                </h4>
                                <div className="welcome-message">
                                    <p className="lead mb-4">
                                        Has iniciado sesión exitosamente en el sistema.
                                    </p>
                                    <p className="text-muted">
                                        Utiliza el menú de navegación en la parte superior 
                                        para acceder a las funciones disponibles para tu perfil.
                                    </p>
                                </div>
                                <div className="welcome-features mt-5">
                                    <Row>
                                        <Col md={4} className="mb-3">
                                            <div className="feature-box">
                                                <i className="fas fa-shopping-cart fa-2x mb-3"></i>
                                                <h6>Ventas</h6>
                                                <small className="text-muted">
                                                    Gestiona tus ventas
                                                </small>
                                            </div>
                                        </Col>
                                        <Col md={4} className="mb-3">
                                            <div className="feature-box">
                                                <i className="fas fa-users fa-2x mb-3"></i>
                                                <h6>Clientes</h6>
                                                <small className="text-muted">
                                                    Administra clientes
                                                </small>
                                            </div>
                                        </Col>
                                        <Col md={4} className="mb-3">
                                            <div className="feature-box">
                                                <i className="fas fa-calendar-alt fa-2x mb-3"></i>
                                                <h6>Citas</h6>
                                                <small className="text-muted">
                                                    Programa citas
                                                </small>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default WelcomeScreen;

